export const meta = {
  id: 'M06',
  slug: 'acompanhar-jornada-formacoes',
  title: 'Como acompanhar Jornada e Formações',
  description: 'Acompanhe posição, progresso, bloqueios e próxima ação do mentorado em sua Jornada e Formações.',
  profile: 'mentor',
  category: 'jornada-formacoes',
  type: 'task',
  status: 'published',
  order: 270,
  keywords: ['jornada', 'formações', 'mentorado', 'progresso', 'bloqueio', 'pré-requisito', 'próxima ação'],
  previous: 'M05',
  next: 'M07',
  related: ['A05', 'A06', 'A07', 'M07'],
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Como acompanhar Jornada e Formações

A Jornada mostra o caminho de desenvolvimento do mentorado. As Formações organizam programas estruturados com etapas, componentes, regras de liberação e progresso.

## O que observar

- posição atual do mentorado;
- conteúdos ou componentes concluídos;
- itens pendentes;
- progresso da Jornada ou Formação;
- componentes bloqueados;
- pré-requisitos ainda não cumpridos;
- próxima ação disponível.

## Como usar no acompanhamento

<Steps>
  <Step title="Identifique onde o mentorado está">
    Localize a etapa, componente ou experiência atual.
  </Step>
  <Step title="Observe o que impede avanço">
    Um item bloqueado pode depender de pré-requisito, atividade, treinamento ou outra condição da Formação.
  </Step>
  <Step title="Conecte ao objetivo de desenvolvimento">
    Use o progresso para conversar sobre aplicação, dificuldade, ritmo e aprendizado.
  </Step>
</Steps>

<Callout type="important">
  Não interprete um componente bloqueado como falta de iniciativa sem verificar a regra de liberação. O Personagrama pode estar aguardando um pré-requisito real.
</Callout>

<HelpImage alt="Jornada e Formações do mentorado" pendingId="M06.1" />
